import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { environment } from "../environments/environment";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";

import { AuthenticationModule } from "./core/auth/authentication.module";
import { NgxPermissionsModule } from "ngx-permissions";

import { HttpClientInMemoryWebApiModule } from "angular-in-memory-web-api";
// import { FakeApiService } from './fake-api/fake-api.service';

import { LayoutModule } from "./content/layout/layout.module";
import { PartialsModule } from "./content/partials/partials.module";
import { CoreModule } from "./core/core.module";
import { AclService } from "./core/services/acl.service";
import { LayoutConfigService } from "./core/services/layout-config.service";
import { MenuConfigService } from "./core/services/menu-config.service";
import { PageConfigService } from "./core/services/page-config.service";
import { UserService } from "./core/services/user.service";
import { UtilsService } from "./core/services/utils.service";
import { ClassInitService } from "./core/services/class-init.service";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from "@angular/material/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { OverlayModule } from "@angular/cdk/overlay";

import { MessengerService } from "./core/services/messenger.service";
import { ClipboardService } from "./core/services/clipboard.sevice";

import { PERFECT_SCROLLBAR_CONFIG } from "ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { LayoutConfigStorageService } from "./core/services/layout-config-storage.service";
import { LogsService } from "./core/services/logs.service";
import { QuickSearchService } from "./core/services/quick-search.service";
import { SubheaderService } from "./core/services/layout/subheader.service";
import { HeaderService } from "./core/services/layout/header.service";
import { MenuHorizontalService } from "./core/services/layout/menu-horizontal.service";
import { MenuAsideService } from "./core/services/layout/menu-aside.service";
import { LayoutRefService } from "./core/services/layout/layout-ref.service";
import { SplashScreenService } from "./core/services/splash-screen.service";
import { DataTableService } from "./core/services/datatable.service";
import { SuperAdminGuard } from "./guards/superadmin.guard";
import { RequestInterceptorService } from "./services/request-interceptor.service";
import { ResponseInterceptorService } from "./services/response-interceptor.service";

import { StoreModule } from "@ngrx/store";

import { ClipboardModule } from "ngx-clipboard";

import { IntercomModule } from "ng-intercom";

import { QuillModule } from 'ngx-quill'

// import { StatusComponent } from './content/pages/showroom/orders/orders-index/statuses/status.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
	// suppressScrollX: true
};

@NgModule({
	declarations: [
		AppComponent
		// StatusComponent,
	],
	imports: [
		BrowserAnimationsModule,
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,
		AppRoutingModule,
		HttpClientModule,
		//	environment.isMockEnabled ? HttpClientInMemoryWebApiModule.forRoot(FakeApiService) : [],
		LayoutModule,
		PartialsModule,
		CoreModule,
		OverlayModule,
		AuthenticationModule,
		NgxPermissionsModule.forRoot(),
		// NgbModule.forRoot(),
		TranslateModule.forRoot(),
		MatProgressSpinnerModule,

		ClipboardModule,

		QuillModule.forRoot(),

		IntercomModule.forRoot({
			appId: "qz0rtcot" // from your Intercom config
			// will automatically run `update` on router event changes. Default: `false`
			// updateOnRouterChange: true
		}),
		StoreModule.forRoot({})
	],
	providers: [
		AclService,
		LayoutConfigService,
		LayoutConfigStorageService,
		LayoutRefService,
		MenuConfigService,
		PageConfigService,
		UserService,
		UtilsService,
		ClassInitService,
		MessengerService,
		ClipboardService,
		LogsService,
		QuickSearchService,
		DataTableService,
		SplashScreenService,
		{
			provide: PERFECT_SCROLLBAR_CONFIG,
			useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
		},

		// template services
		SubheaderService,
		HeaderService,
		MenuHorizontalService,
		MenuAsideService,
		SuperAdminGuard,
		// Http interceptor for adding jwt token
		{
			provide: HTTP_INTERCEPTORS,
			useClass: RequestInterceptorService,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ResponseInterceptorService,
			multi: true
		}
	],
	bootstrap: [AppComponent]
})
export class AppModule {}
